import React, { useEffect } from 'react';
import { styled } from '@mui/material';

import { useAppDispatch } from '../state/hooks';
import { fetchShippers } from '../state/features/shippersSlice';
import { useFilters } from '../components/Filters/useFilters';
import BasePage from './Layouts/BasePage';
import PageBanner from './Layouts/PageBanner';
import PagePaper from './Layouts/PagePaper';
import PageContent from './Layouts/PageContent';
import ShipperTable from '../components/Tables/ShipperTable';
import ShipperKPIs from '../components/KPIs/ShipperKPIs';

const classesPrefix = 'shippers';

const classes = {
    wrapper: `${classesPrefix}-wrapper`,
};

const StyledDiv = styled('div')(() => {
    return {
        [`&.${classes.wrapper}`]: {
            width: '100%',
        },
    };
});

const Shippers = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const filters = useFilters();

    useEffect(() => {
        dispatch(fetchShippers({
            filter_criteria: filters,
        }));
    }, [dispatch, filters]);

    return (
        <BasePage>
            <PageBanner>
                <ShipperKPIs />
            </PageBanner>
            <PagePaper>
                <PageContent>
                    <StyledDiv className={classes.wrapper}>
                        <ShipperTable />
                    </StyledDiv>
                </PageContent>
            </PagePaper>
        </BasePage>
    );
};

export default Shippers;
